const MuiStepLabel = {
  root: {
    flexDirection: 'column'
  },
  iconContainer: {
    margin: 0,
    paddingRight: 0
  },
  labelContainer: {
    '& > .MuiStepLabel-label': {
      marginTop: 10,
      textAlign: 'center'
    },
    '& > .MuiStepLabel-label:empty': {
      marginTop: 0
    }
  }
};
export default MuiStepLabel;